module.exports = __webpack_public_path__ + "img/help_message_en.0bec3dcd.png";